module.exports = __webpack_public_path__ + "static/media/Prosper-Card-Front.03ec7ed2.png";